import { type ReactElement } from 'react';
import { roundTo } from '@optimization/ssi-common';
import { NotAvailable } from '../../../NotAvailable';
import styles from './style.module.scss';

interface CycledEnergyCellProperties {
  readonly cycledEnergyKwh?: number;
  readonly cycledEnergyRatio?: number;
}

const formatMwh = (cycledEnergyKwh: number): string => roundTo(cycledEnergyKwh / 1000, 1).toFixed(1);

const formatPercentage = (cycledEnergyRatio?: number): string | null => {
  if (typeof cycledEnergyRatio !== 'number') {
    return null;
  }

  return `${Math.round(cycledEnergyRatio * 100)
    .toString()
    .padStart(2, '0')}%`;
};

const CycledEnergyCell = ({ cycledEnergyKwh, cycledEnergyRatio }: CycledEnergyCellProperties): ReactElement => {
  if (typeof cycledEnergyKwh !== 'number') {
    return (
      <div className={styles.content} data-testid="cycled-energy-cell">
        <NotAvailable />
      </div>
    );
  }

  const formattedMwh = formatMwh(cycledEnergyKwh);
  const formattedPercentage = formatPercentage(cycledEnergyRatio);

  return (
    <div className={styles.content} data-testid="cycled-energy-cell">
      {formattedMwh} <span className="tds-text-grey-350">MWh</span>
      {formattedPercentage && ` (${formattedPercentage})`}
    </div>
  );
};

export default CycledEnergyCell;
